import type { z } from 'zod';
import type { PaginationParams } from '../types/Pagination.types';
import type { WalletTransactionPaginationDto } from './wallet.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';

import { PaginationParamsSchema } from '../types/Pagination.types';
import { WalletDetailsDtoSchema, WalletDtoSchema, WalletTransactionPaginationSchema } from './wallet.schema';

export const walletApi = {
  async getMe(): Promise<z.infer<typeof WalletDtoSchema>> {
    const response = await httpClient.get<z.infer<typeof WalletDtoSchema>>(ENDPOINTS.wallet.me);

    return validateWithZod(WalletDtoSchema, response);
  },

  async getMeDetails(): Promise<z.infer<typeof WalletDetailsDtoSchema>> {
    const response = await httpClient.get<z.infer<typeof WalletDetailsDtoSchema>>(ENDPOINTS.wallet.details);

    return validateWithZod(WalletDetailsDtoSchema, response);
  },

  async getTransactions(params?: PaginationParams): Promise<WalletTransactionPaginationDto> {
    const validatedParams = validateWithZod(PaginationParamsSchema(), params);

    const response = await httpClient.get<WalletTransactionPaginationDto>(ENDPOINTS.wallet.transactions, {
      params: validatedParams,
    });

    return validateWithZod(WalletTransactionPaginationSchema, response);
  },
};
